import { render, staticRenderFns } from "./ForumActivityAdmin.vue?vue&type=template&id=46930976"
import script from "./ForumActivityAdmin.vue?vue&type=script&lang=js"
export * from "./ForumActivityAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports